import { TuneVerticalIcon } from './TuneVerticalIcon';

/**
 * author: Google
 * id AB147073-9D20-4DA1-A108-3856FC1764C1
 * name tune-vertical
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tune-vertical.svg
 * tags
 * - Settings 
 * - Audio 
 */
export const EqualiserVerticalIcon = TuneVerticalIcon;
export default EqualiserVerticalIcon